/** Typed `field_config` for LIVE_25_EVENT_FORM fields (optional override for the embedded 25Live event form configuration). */
export function parseLive25EventFormFieldConfig(fieldDef: { fieldConfig?: string }): {
    eventFormConfigurationId: number | null;
} {
    if (!fieldDef.fieldConfig?.trim()) {
        return { eventFormConfigurationId: null };
    }
    try {
        const parsed = JSON.parse(fieldDef.fieldConfig) as { eventFormConfigurationId?: number };
        const configId = parsed?.eventFormConfigurationId;
        // 0 is the unset sentinel on security groups / admin "no selection" — not a real configuration_id
        if (typeof configId === "number" && Number.isFinite(configId) && configId > 0) {
            return { eventFormConfigurationId: configId };
        }
    } catch {
        /* ignore */
    }
    return { eventFormConfigurationId: null };
}
